import { render, staticRenderFns } from "./ProductsSettings.vue?vue&type=template&id=280e416a"
import script from "./ProductsSettings.vue?vue&type=script&lang=js"
export * from "./ProductsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports